import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'LayersIcon',
  viewBox: '0 0 16 16',
  defaultProps: {
    boxSize: 4,
  },
  path: (
    <path
      d="M1.333 11.333 8 14.667l6.667-3.334M1.333 8 8 11.333 14.667 8M8 1.333 1.333 4.667 8 8l6.667-3.333L8 1.333Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
});
